import { db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { tenantToFirestore, tenantFromFirestore } from "../models/tenant";
import AuditService, { AUDIT_ACTIONS, AUDIT_MODULES } from "./audit_service";

/**
 * TenantService
 * Centraliza as operações de banco de dados para o Tenant (empresa).
 * Documento: tenants/{idTenant}
 */
const TenantService = {
    /**
     * Busca os dados da empresa (Tenant) atual.
     */
    getTenantInfo: async (idTenant) => {
        if (!idTenant) throw new Error("ID da empresa (Tenant) não fornecido.");

        const docRef = doc(db, "tenants", idTenant);
        const snapshot = await getDoc(docRef);

        return tenantFromFirestore(snapshot);
    },

    /**
     * Atualiza os dados principais da empresa (Tenant)
     */
    updateTenantInfo: async (tenantData, authUser) => {
        const idTenant = tenantData.id;
        if (!idTenant) throw new Error("ID da empresa inválido para atualização.");

        const docRef = doc(db, "tenants", idTenant);
        const payload = tenantToFirestore(tenantData, authUser);

        // Removemos o status 'isActive' do update para não sobrescrever caso esteja desativado
        delete payload.isActive;
        
        // merge = true para atualizar apenas as propriedades enviadas sem apagar integrações e configurações
        await setDoc(docRef, payload, { merge: true });

        // Auditoria
        AuditService.log({
            idTenant,
            user: authUser,
            module: AUDIT_MODULES.SETTINGS,
            action: AUDIT_ACTIONS.UPDATE,
            entityId: idTenant,
            entityName: payload.tradeName || idTenant,
            description: `Atualizou os dados da empresa "${payload.tradeName || idTenant}"`
        });

        return { id: idTenant, ...payload };
    }
};

export default TenantService;
